var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-row",
        [
          _c(
            "b-col",
            [
              _c("header-view", {
                attrs: {
                  title: _vm.$t("message.contactPersonList.title"),
                  icon: "ti-user"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        { staticClass: "mt-4" },
        [
          _c(
            "b-col",
            [
              _c(
                "b-card",
                { staticClass: "rounded-0" },
                [
                  _c(
                    "b-row",
                    [
                      _c("b-col", [
                        _c("p", [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "message.contactPersonList.introductoryPhrase"
                              )
                            )
                          )
                        ])
                      ])
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm._l(Math.ceil(_vm.contactPersons.length / 2), function(i) {
                    return _c(
                      "b-row",
                      { key: i, staticClass: "mb-lg-4" },
                      [
                        _vm._l(
                          _vm.contactPersons.slice((i - 1) * 2, i * 2),
                          function(contactPerson) {
                            return _c(
                              "b-col",
                              {
                                key: contactPerson.id + contactPerson.name,
                                staticClass: "mt-md-4 mt-lg-0",
                                attrs: { cols: "12", xl: "6" }
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "p-0 m-0 w-100 cursor-pointer",
                                    class: {
                                      "not-allowed":
                                        contactPerson.status !==
                                        _vm.$t(
                                          "enums.invitationStatus.REGISTERED"
                                        )
                                    },
                                    attrs: {
                                      variant: "transparent",
                                      "router-tag": "div"
                                    },
                                    on: {
                                      click: function($event) {
                                        _vm.showContactPerson(contactPerson)
                                      }
                                    }
                                  },
                                  [
                                    _c("business-card", {
                                      staticClass: "rounded-0 h-100",
                                      attrs: {
                                        name: contactPerson.name,
                                        relation: contactPerson.relationshipType
                                          ? _vm.$t(
                                              "enums.relationTypes." +
                                                contactPerson.relationshipType
                                            )
                                          : null,
                                        email: contactPerson.email,
                                        status: contactPerson.status,
                                        imageSrc: contactPerson.avatarUuid
                                      }
                                    })
                                  ],
                                  1
                                )
                              ]
                            )
                          }
                        ),
                        _vm._v(" "),
                        i == Math.ceil(_vm.contactPersons.length / 2)
                          ? _c(
                              "b-col",
                              {
                                class: {
                                  "mt-4": _vm.contactPersons.length % 2 === 0
                                },
                                attrs: { cols: "12", xl: "6" }
                              },
                              [
                                _c(
                                  "b-btn",
                                  {
                                    staticClass:
                                      "w-100 h-100 pt-4 pb-2 rounded-0",
                                    on: { click: _vm.showContactPersonDialog }
                                  },
                                  [
                                    _c("span", {
                                      staticClass:
                                        "ti-plus font-weight-bold pt-1",
                                      style:
                                        "font-size: 4rem; border: 1px solid #fff; border-radius: 3rem; padding: 5px;"
                                    }),
                                    _vm._v(" "),
                                    _c("p", { staticClass: "mt-4" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "message.contactPersonList.btn.createContactPerson"
                                          )
                                        )
                                      )
                                    ])
                                  ]
                                )
                              ],
                              1
                            )
                          : _vm._e()
                      ],
                      2
                    )
                  }),
                  _vm._v(" "),
                  _vm.contactPersons.length === 0
                    ? _c(
                        "b-row",
                        [
                          _c(
                            "b-col",
                            { attrs: { cols: "6" } },
                            [
                              _c(
                                "b-btn",
                                {
                                  staticClass:
                                    "w-100 h-100 pt-4 pb-2 rounded-0",
                                  on: { click: _vm.showContactPersonDialog }
                                },
                                [
                                  _c("span", {
                                    staticClass:
                                      "ti-plus font-weight-bold pt-1",
                                    style:
                                      "font-size: 4rem; border: 1px solid #fff; border-radius: 3rem; padding: 5px;"
                                  }),
                                  _vm._v(" "),
                                  _c("p", { staticClass: "mt-4" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "message.contactPersonList.btn.createContactPerson"
                                        )
                                      )
                                    )
                                  ])
                                ]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ],
                2
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("contact-person-dialog", {
        ref: "contactPersonDialog",
        on: { submit: _vm.submitContactPersonDialog }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-364d4f59", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-364d4f59","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/contactPerson/ContactPersonList.vue
// module id = WXjA
// module chunks = 1